export default __webpack_public_path__ + "static/media/figma.ddb80767.svg";